export var VERSION = '2.24.0';
//# sourceMappingURL=version.js.map